import React from 'react';
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import "../../../style/PriorityTableStyles/taskstable.css";

export const PaginationTaskTable = ({
                                        pageCounter,
                                        totalPageNumber,
                                        setPageCounter
                                    }) => {


    const handlePreviousPagination = () => {
        if (pageCounter > 1) {
            setPageCounter(pageCounter - 1);
        }
    };

    const handleNextPagination = () => {
        if (pageCounter < totalPageNumber) {
            setPageCounter(pageCounter + 1);
        }
    };

    return (<div>
        <button
            onClick={handlePreviousPagination}
            disabled={pageCounter <= 1}
            title="Forrige side"
            className="pagination-button previous"
        >
            <ArrowBackIosNewRoundedIcon/>
        </button>
        <span className="pagination-counter">
                {totalPageNumber === 0 ? "-" : `${pageCounter}/${totalPageNumber}`}
                    </span>
        <button
            onClick={handleNextPagination}
            disabled={pageCounter === totalPageNumber || totalPageNumber === 0}
            title="Neste side"
            className="pagination-button next"
        >
            <ArrowBackIosNewRoundedIcon className="pagination-icon-flip"/>
        </button>
    </div>)
}
